import { Outlet } from 'react-router'

export default function BlogLayout() {
	return <Outlet />
}
